import type { UrlProjectName } from '../../types';
import type { ProjectData } from './project-data';
import { WILLOW_DATA } from './willow';
import { RIVER_RANCH_DATA } from './river-ranch';
import { HAZEL_DATA } from './hazel';
import { SELLERS_DATA } from './sellers';
import { SPARROW_DATA } from './sparrow';
import { LING_DATA } from './ling';
import { GERANIUM_DATA } from './geranium';
import { INSPIRATION_DATA } from './inspiration';

export type { ProjectData } from './project-data';

export const PROJECT_DATA_MAP: Record<UrlProjectName, ProjectData> = {
  willow: WILLOW_DATA,
  'river-ranch': RIVER_RANCH_DATA,
  hazel: HAZEL_DATA,
  sellers: SELLERS_DATA,
  sparrow: SPARROW_DATA,
  ling: LING_DATA,
  geranium: GERANIUM_DATA,
  inspiration: INSPIRATION_DATA,
};
